import { FlatAspect } from "@/models/HomePageSearchResponse";
import BREED_OPTIONS from "./BreedOptions";
import STALLION_BREED_OPTIONS from "./StallionBreedOptions";

export interface CategoryAspect {
  id: string;
  label: string;
  slug: string;
  children: CategoryAspect[];
  isHorses?: boolean;
}

// AJB: this group and flatten business still make sense?
export function FlattenCategories(
  aspects: CategoryAspect[],
  level: number = 0,
  topId: string | null = null,
): FlatAspect[] {
  return aspects.flatMap((aspect) => [
    MapCategoryAspectToFlatAspect(aspect, level, topId ?? aspect.id),
    ...FlattenCategories(aspect.children, level + 1, topId ?? aspect.id),
  ]);
}

export function MapCategoryAspectToFlatAspect(
  category: CategoryAspect,
  level: number = 0,
  topId: string | null = null,
): FlatAspect {
  return {
    id: category.id.toString(),
    label: category.label,
    level,
    topId: topId ?? category.id,
    slug: category.slug,
  };
}

const CATEGORY_HIERARCHY: CategoryAspect[] = [
  {
    id: "196",
    label: "Horses",
    slug: "horses",
    children: BREED_OPTIONS.map((breed): CategoryAspect | null =>
      breed.slug
        ? {
            id: breed.id,
            label: breed.label,
            slug: breed.slug,
            children: [],
          }
        : null,
    ).filter((breed) => breed !== null),
    isHorses: true,
  },
  {
    id: "197",
    label: "Stallions at Stud",
    slug: "stallions-at-stud",
    children: STALLION_BREED_OPTIONS.map((breed): CategoryAspect | null =>
      breed.slug
        ? {
            id: breed.id,
            label: breed.label,
            slug: breed.slug,
            children: [],
          }
        : null,
    ).filter((breed) => breed !== null),
    isHorses: true,
  },
  {
    id: "198",
    label: "Saddlery, Tack & Apparel",
    slug: "saddlery-tack-apparel",
    children: [
      {
        id: "283",
        label: "Bridleware",
        slug: "bridleware",
        children: [
          {
            id: "287",
            label: "Bits",
            slug: "bits",
            children: [],
          },
          {
            id: "284",
            label: "English",
            slug: "english",
            children: [],
          },
          {
            id: "286",
            label: "Other",
            slug: "other-saddlery-tack-apparel",
            children: [],
          },
          {
            id: "285",
            label: "Western",
            slug: "western-saddlery-tack-apparel",
            children: [],
          },
        ],
      },
      {
        id: "301",
        label: "Harness",
        slug: "harness",
        children: [],
      },
      {
        id: "288",
        label: "Riding Accessories",
        slug: "riding-accessories",
        children: [
          {
            id: "294",
            label: "Fly veils",
            slug: "fly-veils",
            children: [],
          },
          {
            id: "289",
            label: "Halters and leads",
            slug: "halters-and-leads",
            children: [],
          },
          {
            id: "291",
            label: "Helmets",
            slug: "helmets",
            children: [],
          },
          {
            id: "292",
            label: "Horse Boots",
            slug: "horse-boots",
            children: [],
          },
          {
            id: "298",
            label: "Other",
            slug: "other-riding-accessories",
            children: [],
          },
          {
            id: "293",
            label: "Rugs",
            slug: "rugs",
            children: [],
          },
          {
            id: "297",
            label: "Saddle accessories",
            slug: "saddle-accessories",
            children: [],
          },
          {
            id: "290",
            label: "Saddle cloths",
            slug: "saddle-cloths",
            children: [],
          },
          {
            id: "295",
            label: "Spurs",
            slug: "spurs",
            children: [],
          },
          {
            id: "296",
            label: "Whips",
            slug: "whips",
            children: [],
          },
        ],
      },
      {
        id: "299",
        label: "Riding Apparel",
        slug: "riding-apparel",
        children: [
          {
            id: "310",
            label: "Chaps and chappettes",
            slug: "chaps-and-chappettes",
            children: [],
          },
          {
            id: "309",
            label: "Clothing accessories",
            slug: "clothing-accessories",
            children: [],
          },
          {
            id: "308",
            label: "General clothing",
            slug: "general-clothing",
            children: [],
          },
          {
            id: "312",
            label: "Gloves",
            slug: "gloves",
            children: [],
          },
          {
            id: "307",
            label: "Hats",
            slug: "hats",
            children: [],
          },
          {
            id: "306",
            label: "Jacket and vests",
            slug: "jacket-and-vests",
            children: [],
          },
          {
            id: "304",
            label: "Jodhpurs",
            slug: "jodhpurs",
            children: [],
          },
          {
            id: "313",
            label: "Other",
            slug: "other-riding-apparel",
            children: [],
          },
          {
            id: "311",
            label: "Riding Boots",
            slug: "riding-boots",
            children: [],
          },
          {
            id: "305",
            label: "Shirts",
            slug: "shirts",
            children: [],
          },
          {
            id: "303",
            label: "Wet weather gear",
            slug: "wet-weather-gear",
            children: [],
          },
        ],
      },
      {
        id: "300",
        label: "Riding equipment",
        slug: "riding-equipment",
        children: [
          {
            id: "315",
            label: "Dressage arena markers",
            slug: "dressage-arena-markers",
            children: [],
          },
          {
            id: "314",
            label: "Jumps",
            slug: "jumps",
            children: [],
          },
          {
            id: "319",
            label: "Other",
            slug: "other-riding-equipment",
            children: [],
          },
          {
            id: "317",
            label: "Polo equipment",
            slug: "polo-equipment",
            children: [],
          },
          {
            id: "316",
            label: "Polocrosse equipment",
            slug: "polocrosse-equipment",
            children: [],
          },
          {
            id: "318",
            label: "Timing equipment",
            slug: "timing-equipment",
            children: [],
          },
        ],
      },
      {
        id: "275",
        label: "Saddles",
        slug: "saddles",
        children: [
          {
            id: "278",
            label: "All purpose",
            slug: "all-purpose",
            children: [],
          },
          {
            id: "281",
            label: "Children",
            slug: "children",
            children: [],
          },
          {
            id: "276",
            label: "Dressage and Show",
            slug: "dressage-and-show",
            children: [],
          },
          {
            id: "277",
            label: "Jumping",
            slug: "jumping",
            children: [],
          },
          {
            id: "282",
            label: "Other",
            slug: "other-saddles",
            children: [],
          },
          {
            id: "280",
            label: "Stock",
            slug: "stock",
            children: [],
          },
          {
            id: "279",
            label: "Western",
            slug: "western-saddles",
            children: [],
          },
        ],
      },
      {
        id: "302",
        label: "Training equipment",
        slug: "training-equipment",
        children: [],
      },
    ],
  },
  {
    id: "201",
    label: "Transport & Vehicles",
    slug: "transport-vehicles",
    children: [
      {
        id: "356",
        label: "Floats & Accessories",
        slug: "floats-accessories",
        children: [],
      },
      {
        id: "359",
        label: "Other",
        slug: "other-transport-vehicles",
        children: [],
      },
      {
        id: "357",
        label: "Towing Vehicles",
        slug: "towing-vehicles",
        children: [],
      },
      {
        id: "358",
        label: "Trucks",
        slug: "trucks",
        children: [],
      },
    ],
  },
  {
    id: "202",
    label: "Equine Property",
    slug: "equine-property",
    children: [
      {
        id: "396",
        label: "Agistment",
        slug: "agistment",
        children: [],
      },
      {
        id: "395",
        label: "For Lease/Rent",
        slug: "for-lease-rent",
        children: [],
      },
      {
        id: "393",
        label: "For Sale",
        slug: "property-for-sale",
        children: [],
      },
    ],
  },
  {
    id: "412",
    label: "Retail Zone",
    slug: "retail-zone",
    children: [
      {
        id: "417",
        label: "Apparel",
        slug: "apparel",
        children: [],
      },
      {
        id: "413",
        label: "Feed",
        slug: "feed",
        children: [],
      },
      {
        id: "418",
        label: "Property Improvements",
        slug: "property-improvements",
        children: [],
      },
      {
        id: "416",
        label: "Saddlery",
        slug: "saddlery",
        children: [],
      },
      {
        id: "420",
        label: "Stables",
        slug: "stables",
        children: [],
      },
      {
        id: "414",
        label: "Supplements",
        slug: "supplements",
        children: [],
      },
      {
        id: "415",
        label: "Therapy",
        slug: "therapy",
        children: [],
      },
      {
        id: "419",
        label: "Transport",
        slug: "transport",
        children: [],
      },
    ],
  },
  {
    id: "204|375|199",
    label: "Products & Equipment",
    slug: "products-equipment",
    children: [
      {
        id: "204",
        label: "Giftware & Resources",
        slug: "giftware-resources",
        children: [
          {
            id: "324",
            label: "Art",
            slug: "art",
            children: [],
          },
          {
            id: "331",
            label: "Books/Videos/DVDs",
            slug: "books-videos-dvds",
            children: [
              {
                id: "333",
                label: "Education/Training",
                slug: "education-training",
                children: [],
              },
              {
                id: "332",
                label: "Fiction",
                slug: "fiction",
                children: [],
              },
              {
                id: "334",
                label: "Veterinary",
                slug: "veterinary",
                children: [],
              },
            ],
          },
          {
            id: "325",
            label: "Clothing",
            slug: "clothing",
            children: [],
          },
          {
            id: "329",
            label: "Collectibles",
            slug: "collectibles",
            children: [],
          },
          {
            id: "326",
            label: "Jewellery",
            slug: "jewellery",
            children: [],
          },
          {
            id: "330",
            label: "Memorabilia",
            slug: "memorabilia",
            children: [],
          },
          {
            id: "327",
            label: "Novelty",
            slug: "novelty",
            children: [],
          },
          {
            id: "328",
            label: "Other",
            slug: "other-giftware-resources",
            children: [],
          },
        ],
      },
      {
        id: "375",
        label: "Horse Care Product",
        slug: "horse-care-products",
        children: [],
      },
      {
        id: "199",
        label: "Equine & Farm Equipment",
        slug: "equine-farm-equipment",
        children: [
          {
            id: "336",
            label: "Farm accessories",
            slug: "farm-accessories",
            children: [
              {
                id: "337",
                label: "Arenas",
                slug: "arenas",
                children: [],
              },
              {
                id: "338",
                label: "Barns/Shed/Stabling",
                slug: "barns-shed-stabling",
                children: [],
              },
              {
                id: "344",
                label: "Fencing",
                slug: "fencing",
                children: [],
              },
              {
                id: "339",
                label: "Pools",
                slug: "pools",
                children: [],
              },
              {
                id: "343",
                label: "Portable yards",
                slug: "portable-yards",
                children: [],
              },
              {
                id: "340",
                label: "Sheds",
                slug: "sheds",
                children: [],
              },
              {
                id: "341",
                label: "Stabling",
                slug: "stabling",
                children: [],
              },
              {
                id: "368",
                label: "Training Track",
                slug: "training-track",
                children: [],
              },
              {
                id: "342",
                label: "Water troughs",
                slug: "water-troughs",
                children: [],
              },
            ],
          },
          {
            id: "206",
            label: "Horse accessories",
            slug: "horse-accessories",
            children: [
              {
                id: "208",
                label: "Boots and Bandages",
                slug: "boots-and-bandages",
                children: [],
              },
              {
                id: "345",
                label: "Clippers and accessories",
                slug: "clippers-and-accessories",
                children: [],
              },
              {
                id: "346",
                label: "Farrier tools",
                slug: "farrier-tools",
                children: [],
              },
              {
                id: "348",
                label: "Feed supplies and accessories",
                slug: "feed-supplies-and-accessories",
                children: [],
              },
              {
                id: "347",
                label: "Foaling supplies",
                slug: "foaling-supplies",
                children: [],
              },
              {
                id: "207",
                label: "Grooming equipment",
                slug: "grooming-equipment",
                children: [],
              },
              {
                id: "349",
                label: "Horse health",
                slug: "horse-health",
                children: [],
              },
              {
                id: "350",
                label: "Other",
                slug: "other-horse-accessories",
                children: [],
              },
            ],
          },
          {
            id: "369",
            label: "Motor/quad bikes",
            slug: "motor-quad-bikes",
            children: [],
          },
          {
            id: "372",
            label: "Other",
            slug: "other-equine-farm-equipment",
            children: [],
          },
          {
            id: "371",
            label: "Ride-on mowers",
            slug: "ride-on-mowers",
            children: [],
          },
          {
            id: "335",
            label: "Stable accessories",
            slug: "stable-accessories",
            children: [
              {
                id: "351",
                label: "Feeding equipment",
                slug: "feeding-equipment",
                children: [],
              },
              {
                id: "355",
                label: "Other",
                slug: "other-stable-accessories",
                children: [],
              },
              {
                id: "352",
                label: "Saddle racks",
                slug: "saddle-racks",
                children: [],
              },
              {
                id: "353",
                label: "Tools",
                slug: "tools",
                children: [],
              },
              {
                id: "354",
                label: "Wheel barrows",
                slug: "wheel-barrows",
                children: [],
              },
            ],
          },
          {
            id: "370",
            label: "Tractors",
            slug: "tractors",
            children: [],
          },
        ],
      },
      {
        id: "other-products-equipment",
        label: "Other",
        slug: "other-products-equipment",
        children: [],
      },
    ],
  },
];

export default CATEGORY_HIERARCHY;
